import { Card, Button, Row, Col } from "antd";
import "./LectureCard.less";

const LectureCard = (props) => {
  return (
    <Card className='lecture-card' loading={props.loading}>
      <div className='cover-image'>
        <img
          src={props.lectureImage}
          alt='Lecturer'
          className='lecturer-image'
        />
      </div>
      <Row className='card-content' gutter={[16, 16]}>
        <Col span={16} className='details'>
          <div className='lecture-name'>
            <p className='label'>Lecture name</p>
            <p className='value'>{props.lectureName}</p>
          </div>
          <div className='date-time'>
            <p className='label'>Date & Time</p>
            <p className='value'>{props.dateTime}</p>
          </div>
        </Col>
        <Col span={8} className='join-button-container'>
          <Button
            type='primary'
            className='join-button'
            onClick={() => window.open(props.classUrl)}
          >
            Join
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default LectureCard;
